import { render, staticRenderFns } from "./ym-feed-in-out.vue?vue&type=template&id=44c4c4f9&scoped=true&"
import script from "./ym-feed-in-out.vue?vue&type=script&lang=js&"
export * from "./ym-feed-in-out.vue?vue&type=script&lang=js&"
import style0 from "./ym-feed-in-out.vue?vue&type=style&index=0&id=44c4c4f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c4c4f9",
  null
  
)

export default component.exports